class VerifyMFADetails {
    constructor(props) {
        const {
            payload: {
                data: {
                    securityId,
                },
            },
            userMessage,
        } = props;

        this.securityId = securityId;

        // error message sent from the backend
        this.userMessage = userMessage;
    }
}

export default VerifyMFADetails;
